import { Link } from '@com-delta-idp/mnx-ui-kit';

export interface Actions {
  next: string;
  previous: string;
}

export interface Icon {
  alt: string;
  src: string;
}

export interface Goody {
  icon: Icon;
  name: string;
  link?: Link;
}

export interface AEMTier {
  bannerLabel: string;
  current: string;
  goodies: Goody[];
  medallionId: string;
  memberStatus: string;
  peekBarLabel: string;
  title: string;
}

export interface AEMBenefits {
  actions: Actions;
  tiers: AEMTier[];
  title: string;
  memberLabel: string;
}
